// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"AmountControls_paragraph__1PdVm","wrapper":"AmountControls_wrapper__16a3D","single-control":"AmountControls_single-control__3ns9i"};